import { nanoid } from 'nanoid';

import { AwsCognitoKeyEnum } from '../types/aws-cognito.types.ts';
import { MagicLinkTokenResponse } from '../types/magic-link.types.ts';

type ReturnType = Record<string, string>;

export const mapMagicTokenResponseToAwsCognitoStorageDetails = (props: MagicLinkTokenResponse): ReturnType => {
  const { AccessToken, RefreshToken, IdToken } = props;

  const uniqueKey = nanoid(8);
  const uniqueUserKey = nanoid(8);

  return {
    [`${AwsCognitoKeyEnum.PREFIX}.${uniqueKey}.${AwsCognitoKeyEnum.LAST_AUTH_USER}`]: uniqueUserKey,
    [`${AwsCognitoKeyEnum.PREFIX}.${uniqueKey}.${uniqueUserKey}.${AwsCognitoKeyEnum.ACCESS_TOKEN}`]: AccessToken,
    [`${AwsCognitoKeyEnum.PREFIX}.${uniqueKey}.${uniqueUserKey}.${AwsCognitoKeyEnum.ID_TOKEN}`]: IdToken,
    [`${AwsCognitoKeyEnum.PREFIX}.${uniqueKey}.${uniqueUserKey}.${AwsCognitoKeyEnum.REFRESH_TOKEN}`]: RefreshToken,
  };
};
